import { StoryData } from '@cinch-nx/data-storyblok'
import { BrandPageStory } from '../storyblok'

export const OmodaBrandPageFallbackStory: StoryData<BrandPageStory> = {
  name: 'OMODA',
  created_at: '2025-11-21T09:57:21.768Z',
  published_at: '2025-11-28T14:56:11.633Z',
  id: 114_808_593_501_429,
  uuid: '3027e0ed-24e1-4593-9ae1-8b66f6a6f222',
  content: {
    SEO: [
      {
        _uid: '08ed00b3-3e2a-4d9d-a0cc-e1190abf58b7',
        HowTo: [],
        title: 'OMODA | Latest OMODA cars',
        robots: [],
        component: 'SEO',
        openGraph: [],
        description:
          'Discover OMODA, a pioneering range of petrol, hybrid and electric SUVs with innovative tech and unbeatable value. Find out more.',
        twitterCard: [],
        canonicalUrl: '',
      },
    ],
    _uid: 'c5a68e03-b65d-4a47-8002-0d4da88acfb6',
    body: [
      {
        _uid: '7b0ceb19-73b5-40c9-a3a6-2766a3941208',
        content: [
          {
            _uid: '6288db42-a9b0-4f1f-ae14-50ab8c7d4828',
            text: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: 'center',
                  },
                  content: [
                    {
                      text: 'Welcome to OMODA, an exciting range of cultured and connected SUVs fuelled by petrol, hybrid tech and electric power.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: 'center',
                  },
                  content: [
                    {
                      text: "We're partnering with Marshall Motor Group, one of the UK's leading automotive retailers, to sell brand new OMODA cars. Shop the range and submit your enquiry – the Marshall team will be in touch to discuss how to test drive and buy.",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            component: 'RichText',
          },
          {
            url: '/new-cars/omoda',
            _uid: '517403e6-41b9-410a-91fe-e78ece621f21',
            label: 'Buy a brand new OMODA car',
            component: 'CtaButton',
          },
        ],
        component: 'IntroSection',
      },
      {
        _uid: '55ddd149-9417-4660-aa48-7385411afcd1',
        component: 'LandingTextInlineImageSection',
        textInlineImages: [
          {
            _uid: '230c7f4a-1280-450c-b3b1-9fadcce411ee',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'OMODA 5',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The OMODA 5 is an SUV that illuminates the path ahead with striking T-shaped daytime running lights and carries itself with futuristic flair. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Appreciate the presence of its floating roof design, while the punchy 1.6-litre petrol engine delivers power smoothly via a 7-speed dual-clutch automatic gearbox.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Inside, you’ll find dual 12.3-inch screens, a comfortable, ergonomic cabin and all the safety tech that makes the OMODA 5 ideal for modern life. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 114_850_046_291_505,
              alt: 'A modern white OMODA 5 SUV with a distinctive grille is parked on a cobblestone street, next to a building with green ivy-covered walls.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x400/2d403a2f18/omoda-5-model.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A modern white OMODA 5 SUV with a distinctive grille is parked on a cobblestone street, next to a building with green ivy-covered walls.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
          },
          {
            _uid: '8ce7b3b5-69a2-49d7-82ad-e1b47d55a800',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'OMODA E5',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'OMODA’s all-electric SUV hits all the same notes as the petrol-powered 5, but with the silent sophistication and up to 267-mile range of its electric underpinnings.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The streamlined, aerodynamic shape lets it cut through the air with efficiency, while the 3D Matrix tail lights sign off its memorable departure.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Comfort meets innovation inside thanks to crisp infotainment and dash displays, while an optional Sony sound system and 360 camera add to the E5’s air of sophistication.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 114_849_809_833_514,
              alt: 'A sleek black OMODA E5 SUV driving on an elevated road under a partly cloudy sky, with a modern bridge structure in the background.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x400/528b287d54/omoda-e5-model.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A sleek black OMODA E5 SUV driving on an elevated road under a partly cloudy sky, with a modern bridge structure in the background.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
          },
          {
            _uid: 'e7c0c48a-3175-4a0f-a2ca-244e368eca16',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'OMODA 7',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The OMODA 7 draws you in with a sculpted, modern design language – complete with avant-garde borderless grille and dynamic LED tail lights.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Quietly capable both inside and out, top-tier suspension delivers comfort, and a ‘gliding’ 15.6-inch infotainment display acts as a hub for ultra-convenient remote features.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Available with a 1.6-litre petrol engine or as a Super Hybrid System with up to 56 miles of electric range, plus a 639-litre boot, the OMODA 7 promises ultimate versatility.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 114_849_809_882_667,
              alt: 'Sleek teal OMODA 7 SUV with futuristic design, black roof, and distinctive grille, shown in a studio setting with soft lighting.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x400/f5423c6460/omoda-7-model.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Sleek teal OMODA 7 SUV with futuristic design, black roof, and distinctive grille, shown in a studio setting with soft lighting.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
          },
          {
            _uid: 'c0628ab4-0437-4f16-b5ec-f4e64e4d010f',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'OMODA 9',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'For top-of-the-range poise and performance, there’s the OMODA 9, which deploys golden-ratio design to evoke natural beauty for the ultimate in automotive aesthetics.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Signature LED tail lights leave a lasting impression as the OMODA 9 uses Super Hybrid tech to deliver a combined range of 700 miles, including up to 93 miles of pure electric driving.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'A 1.3m sunroof floods a cabin of unparalleled specification with light, electromagnetic suspension delivers an indulgent ride and a 660-litre boot makes it practical for the whole family. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 114_849_809_829_417,
              alt: 'Black OMODA 9 SUV driving on a rural road with grassy fields and trees under a cloudy sky.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/600x400/e642482561/omoda-9-model.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Black OMODA 9 SUV driving on a rural road with grassy fields and trees under a cloudy sky.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
          },
        ],
      },
      {
        url: '/new-cars/omoda',
        _uid: '0d5d81d6-1baf-48b2-aa21-f423203c4f0f',
        label: 'Shop new OMODA',
        component: 'CtaButton',
      },
      {
        _uid: 'b3c33911-45f2-4ba8-89b2-523507ef72a1',
        title: 'Why choose OMODA?',
        component: 'HighlightsSection',
        highlights: [
          {
            _uid: '409473f0-aa05-4e5c-88b6-70c3c106ec97',
            body: 'Brand new OMODA cars come with a 7-year/100,000-mile warranty as standard.',
            icon: 'shield',
            title: 'Peace of mind',
            component: 'FeatureCard',
          },
          {
            _uid: 'dafee20f-2a15-4b48-a6f7-f5de3683dc85',
            body: 'Unmatched technology, features and innovation in the affordable SUV segment.',
            icon: 'card',
            title: 'Disruptive value',
            component: 'FeatureCard',
          },
          {
            _uid: '0f0dcdd4-6b67-4b42-b507-d07ebab361fe',
            body: 'Ultra-efficient blade cell design batteries and Super Hybrid Systems.',
            icon: 'charge',
            title: 'Electric innovation',
            component: 'FeatureCard',
          },
        ],
      },
      {
        _uid: 'f38c975d-a365-4089-a6de-e00bf1247770',
        title: 'OMODA – Affordable, Tech-Filled Crossover SUVs',
        videoId: 'dhCW9eM2w3w',
        component: 'YoutubeVideo',
        thumbnail: {
          id: null,
          alt: null,
          name: '',
          focus: null,
          title: null,
          source: null,
          filename: '',
          copyright: null,
          fieldtype: 'asset',
          meta_data: {},
        },
        description: '',
        displayHeading: false,
      },
      {
        _uid: 'cb646622-940e-4954-b039-a7763a922c99',
        faqs: [
          {
            _uid: 'f1a09a8b-f4c4-4273-bfc9-f9b2a52d02c9',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Search our range of ',
                      type: 'text',
                    },
                    {
                      text: 'brand new cars',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/new-cars',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ', then submit our quick enquiry form and the Marshall team will call you back to discuss your purchase.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can also visit our new car stores to discover some of the most exciting brands emerging in the UK.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch Chery:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Chery Gatwick',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/gatwick',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Chery Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Chery Medway',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-medway',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch OMODA & JAECOO:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'OMODA & JAECOO Bristol',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/bristol',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'OMODA & JAECOO Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/omoda-jaecoo-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'We’re partnering with Marshall Motor Group to bring our customers brand new cars.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Marshall has over 115 years of motoring know-how and is one of the UK’s largest motor retailers, so our customers benefit from the shared experience of both brands.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title: 'How can I buy a new car on cinch?',
            component: 'AccordionItem',
          },
          {
            _uid: '5c80627e-6ad0-471a-aa31-73ed628a5bd7',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Of course, you can test drive new cars at the stores below. You’ll find addresses, opening hours and contact details when you click the relevant link.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Marshall BYD stores:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Ashford',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-ashford/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Canterbury',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-canterbury/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Maidstone',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-maidstone/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Northampton',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-northampton/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Peterborough',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-peterborough/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'St Neots',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-st-neots/',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch Chery Stores:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Gatwick',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/gatwick',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Medway',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/chery-medway',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch OMODA & JAECOO Stores:',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Bristol',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/bristol',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Manchester',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/store/omoda-jaecoo-manchester',
                                    uuid: null,
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'Can I test drive a new car?',
            component: 'AccordionItem',
          },
          {
            _uid: 'ba086679-9a93-4cba-8d45-b784d9e99c3b',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can pay for a new car however it suits you – buy outright or on finance (Hire Purchase or Personal Contract Purchase).',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Since your purchase is handled by Marshall Motor Group, one of the UK’s largest motor retailers, they’ll talk you through your options after you submit your enquiry.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'What are my payment options when buying a new car?',
            component: 'AccordionItem',
          },
          {
            _uid: '87429e04-becc-44c0-8571-eaa9c6cbf6ab',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The Marshall team will talk you through your options for delivery and/or collection – and how long they’ll take – when they call you back after your enquiry.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'How can I get my new car?',
            component: 'AccordionItem',
          },
        ],
        title: 'Frequently Asked Questions',
        component: 'FaqSection',
      },
    ],
    hero: [
      {
        _uid: 'e3e6693c-5a25-4ca2-b359-10ea401abc3a',
        logo: {
          id: 116_235_864_237_024,
          alt: 'OMODA logo in white',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/150x20/218b2b4f37/omoda-logo-white.svg',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'OMODA logo in white',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        image: {
          id: 114_850_247_491_129,
          alt: 'Sleek silver OMODA 5 SUV with black alloy wheels, angular headlights, and a modern grille, parked against a white background.',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/2460x1164/bac3d8e0d8/omoda-5-hero.webp',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Sleek silver OMODA 5 SUV with black alloy wheels, angular headlights, and a modern grille, parked against a white background.',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        heading: 'Futuristic SUVs from OMODA',
        component: 'LandingHero',
        ctaButton: [
          {
            url: '/new-cars/omoda',
            _uid: 'bd609d4d-966a-4134-9ebc-831ca504fac3',
            label: 'Shop new OMODA',
            component: 'HeroCtaButton',
          },
        ],
      },
    ],
    component: 'LandingPage',
  },
  slug: 'omoda',
  full_slug: 'landing/omoda',
  sort_by_date: null,
  position: 10,
  tag_list: [],
  is_startpage: false,
  parent_id: 96_553_270_937_130,
  meta_data: null,
  group_id: '53382bed-2a8e-457f-a98d-4c549dc249c6',
  first_published_at: '2025-11-21T15:09:51.685Z',
  lang: 'default',
  path: 'omoda',
  alternates: [],
}
